var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "editMileageRateModal",
      staticClass: "edit-mileage-rate-modal",
      attrs: {
        id: "editMileageRateModal",
        "hide-header": "",
        "hide-footer": ""
      }
    },
    [
      _c("div", { staticClass: "modal-mileage-rate-wrapper" }, [
        _c("div", {}, [_vm._v("Edit MILEAGE RATE")]),
        _vm._v(" "),
        _c("div", { staticClass: "ap-field-input-wrapper" }, [
          _c("div", { staticClass: "title-field" }, [_vm._v("MILEAGE RATE")]),
          _vm._v(" "),
          _c("div", { staticClass: "ap-input-wrapper" })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d88948cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d88948cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/globalSettings/EditMileageRateModal.vue
// module id = 2065
// module chunks = 1